import LightOffIcon from './component'

export default LightOffIcon
